import light from './light';
import dark from './dark';
import secondary from './secondary';
import primary from './primary';
import custom from './custom';

export default {
  light,
  dark,
  secondary,
  primary,
  custom,
};
